import './Select.scss'

import { useCallback, useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import Input from '../Input/Input'
import useOutclick from '../../../hooks/Outclick'
import Tooltip from '../../core/Tooltip/Tooltip'
import unidecode from 'unidecode'

const Select = ({ control, options = [], label = '', placeholder = 'Select', disabled, onChange, onSelect, defaultValue, className, filterAdd, filterFrom = 5 }) => {
    const [optionsVisible, setOptionsVisible] = useState(false)
    const [visibleOptions, setVisibleOptions] = useState()
    const [currentOption, setCurrentOption] = useState(null)
    const [searchedLabel, setSearchedLabel] = useState()
    const [optionsStyles, setOptionsStyles] = useState({})
    const selectRef = useRef(null)
    const closeOptions = useCallback(() => setOptionsVisible(false), [])

    const selectOption = (option) => {
        if (option?.value !== currentOption?.value) {
            if (control) control.setValue(option?.value)
            setCurrentOption(option)
            if (onChange) onChange(option?.value)
            if (onSelect) onSelect(option)
        }
    }

    const updateFromValue = (value) => {
        const valueOption = options.find((option) => option.value === value)
        if (!valueOption || value !== currentOption?.value) {
            setCurrentOption(valueOption)
            if (onChange) onChange(valueOption?.value)
            if (onSelect) onSelect(valueOption)
        }
    }

    const handleOptionClick = (option) => {
        selectOption(option)
        setOptionsVisible(false)
    }

    const filterOptions = () => {
        setVisibleOptions(options.filter((option) => {
            const searchEmpty = !searchedLabel
            const label = option.label.toLowerCase()
            const search = searchedLabel?.toLowerCase()
            const searchMatch = label.includes(search) || unidecode(label.toLowerCase()).includes(search)

            return searchEmpty || searchMatch
        }).slice(0, filterFrom || 100))
    }

    useOutclick(selectRef, closeOptions)

    useEffect(() => {
        if (control && options.length) updateFromValue(control.value)
        else if (options.length === 1 && !currentOption) selectOption(options[0])
    }, [options])

    useEffect(() => {
        if (control) updateFromValue(control.value)
    }, [control?.value])

    useEffect(() => {
        if (!optionsVisible) {
            setOptionsStyles({})
            setSearchedLabel(null)
        } else {
            const selectBounds = selectRef.current.getBoundingClientRect()
            setOptionsStyles({
                minWidth: selectBounds.width,
                top: selectBounds.top + selectBounds.height + 8,
                left: selectBounds.left,
            })
        }
    }, [optionsVisible])

    useEffect(() => {
        filterOptions()
    }, [options, searchedLabel])

    useEffect(() => {
        updateFromValue(control ? control.value : defaultValue)
    }, [])

    return (
        <div className="flex-column">
            {label && <label>{label}</label>}
            <div className="select" ref={selectRef}>
                <button type="button" className={`toggle ${className}`} disabled={disabled} onClick={() => setOptionsVisible(!optionsVisible)}>
                    {currentOption?.label || (placeholder !== false && <span className="placeholder">{placeholder}</span>)}
                </button>

                {!!options.length && optionsVisible && createPortal(
                    <ul className="portal select-options" style={optionsStyles}>
                        {(filterAdd || options.length > (filterFrom || 100)) && (
                            <li className="option dull pt-3">
                                <div className="row align-items-center">
                                    <div className="col">
                                        <Input className="bordered base" onChange={setSearchedLabel} placeholder="Filter" />
                                    </div>
                                    <div className="col-auto pl-0">
                                        {filterAdd && (
                                            <Tooltip text={filterAdd.tooltip}>
                                                <button type="button" className="primary medium icon" onClick={() => filterAdd.onClick(searchedLabel)}>
                                                    <img src="/images/icons/plus.svg" />
                                                </button>
                                            </Tooltip>
                                        )}
                                    </div>
                                </div>
                            </li>
                        )}
                        {visibleOptions.map((option) => (
                            <li className="option" onClick={() => handleOptionClick(option)} key={option.value}>{option.label}</li>
                        ))}                        
                    </ul>, document.body
                )}
            </div>
        </div>
    )
}

export default Select